import type { FC } from 'react';
import type { IconProps } from './types';

const Undo: FC<IconProps> = ({ color = 'currentColor', size = 24, strokeWidth = 1.5, ...props }) => {
  const calculatedStrokeWidth = (Number(strokeWidth) * 24) / Number(size);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      color={color}
      fill="none"
      stroke={color}
      strokeWidth={calculatedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C8.66873 3 5.76018 4.80989 4.20404 7.5" />
      <path d="M3 3V4.27816C3 6.47004 3 7.56599 3.70725 8.16512C4.4145 8.76425 5.49553 8.58408 7.6576 8.22373L9 8" />
    </svg>
  );
};

export default Undo;
